import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PluginMarketplaceV2 } from '../plugins/components/PluginMarketplaceV2';

/**
 * Marketplace Page - Storefront View
 * Reuses the plugins marketplace for the storefront tab
 */
import { withRequiredPermission } from '@/components/auth/with-required-permission';
import { PERMISSIONS } from '@/hooks/use-perm';

export default withRequiredPermission(StorefrontMarketplacePage, PERMISSIONS.STORES_VIEW);

function StorefrontMarketplacePage() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation('stores');

  if (!id) {
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <p className="text-muted-foreground">{t('marketplace.noStoreSelected')}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <div className="mb-2 flex flex-col gap-2 sm:mb-3 sm:flex-row sm:items-center sm:justify-between sm:gap-3">
        <div className="flex items-center gap-3">
          <div>
            <h1 className="text-xl font-semibold sm:text-2xl">{t('marketplace.title')}</h1>
            <p className="text-muted-foreground text-sm">{t('marketplace.description')}</p>
          </div>
        </div>
      </div>

      <PluginMarketplaceV2 storeId={id} />
    </div>
  );
}
